import { FC } from "react";
import Image from "next/image";
import Link from "next/link";
import { motion } from "framer-motion";
import { GLOBAL_CONFIG } from "@shared/constants";
import { ProjectConfig } from "@shared/types";
import {
  TwitterIcon,
  InstagramIcon,
  DiscordIcon,
  DustLabsIcon,
  MagicEdenIcon,
} from "@shared/components";

const Footer: FC = () => {
  const {
    SITE_NAME,
    ASSETS,
    DISCORD,
    TWITTER,
    INSTAGRAM,
    FOOTER_LOGO_DARK,
    FOOTER_LOGO_LIGHT,
    ORG_NAME,
  } = GLOBAL_CONFIG as ProjectConfig;

  return (
    <motion.footer
      className={`relative border-t-[1px] bg-lightCard border-black transition-colors ease-in-out duration-700 md:flex justify-between items-center py-2 md:py-10 w-full lg:mb-0`}
      {...GLOBAL_CONFIG.OPACITY_ANIMATION}
    >
      <div className="flex flex-col relative justify-center md:justify-start items-center py-2 md:py-0 w-full md:w-1/3 md:justify-self-start gap-2">
        <div className="flex flex-col items-center">
          <Image
            src={`${ASSETS}${FOOTER_LOGO_LIGHT.image}`}
            alt="Footer Left Logo"
            height={`${FOOTER_LOGO_LIGHT.height}`}
            width={`${FOOTER_LOGO_LIGHT.width}`}
          />
        </div>
        {ORG_NAME === "DeGods" ? null : (
          <Link
            href="https://www.dustlabs.com/"
            passHref
            className="cursor-pointers "
            target="_blank"
            rel="noopener noreferrer"
          >
            <DustLabsIcon />
          </Link>
        )}
      </div>

      <div className="w-full h-full md:w-1/3 flex flex-col items-center justify-between py-2 md:py-0">
        <div className="text-xs text-center text-lightFontPrimary">
          Get these apps for your community.{" "}
          <a
            href="https://share.hsforms.com/1j8d_YDFnQsaSHii6z6jkFwdjd9g"
            target="_blank"
            rel="noreferrer noopener"
            className="text-[#1B73DA]"
          >
            Get Started
          </a>
        </div>
        <div
          className="text-xs text-fontSecondary text-center py-3"
          data-cy="footerCopyright"
        >
          © {new Date().getFullYear()} {SITE_NAME}. All rights reserved.
        </div>
      </div>

      <div className="w-full md:w-1/3 flex flex-col justify-center md:justify-end items-center gap-2 lg:gap-3  py-4 md:py-0">
        <div className="flex gap-4 items-center mb-2">
          <Link href={DISCORD} passHref legacyBehavior>
            <motion.a
              className="cursor-pointer no-underline"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              transition={{ duration: 0.2 }}
            >
              <DiscordIcon />
            </motion.a>
          </Link>
          <Link href={TWITTER} passHref legacyBehavior>
            <motion.a
              className="cursor-pointer no-underline"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              transition={{ duration: 0.2 }}
            >
              <TwitterIcon />
            </motion.a>
          </Link>
          <Link href={INSTAGRAM} passHref legacyBehavior>
            <motion.a
              className="cursor-pointer no-underline"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              transition={{ duration: 0.2 }}
            >
              <InstagramIcon />
            </motion.a>
          </Link>
        </div>
        {ORG_NAME !== "DeGods" ? null : (
          <Link
            href="https://www.dustlabs.com/"
            passHref
            className="cursor-pointers "
            target="_blank"
            rel="noopener noreferrer"
          >
            <DustLabsIcon />
          </Link>
        )}
      </div>
    </motion.footer>
  );
};

export default Footer;
